import CommonMiddleware from 'yoda-site-components/lib/middlewares/CommonMiddleware';
import CommonCJAMiddleware from 'yoda-site-components/lib/middlewares/CommonCJAMiddleware';
import CheckoutMiddleware from 'yoda-checkout-components/lib/middlewares/CheckoutAnalyticsMiddleware';

const rootMiddleware = [CommonMiddleware, CommonCJAMiddleware, CheckoutMiddleware];

export default rootMiddleware;
